import { render, staticRenderFns } from "./PaymentRedirectTemplate.vue?vue&type=template&id=138d9490&scoped=true"
import script from "./PaymentRedirectTemplate.vue?vue&type=script&lang=js"
export * from "./PaymentRedirectTemplate.vue?vue&type=script&lang=js"
import style0 from "./PaymentRedirectTemplate.vue?vue&type=style&index=0&id=138d9490&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "138d9490",
  null
  
)

export default component.exports